<template>
    <b-container fluid>
        <vue-toastr ref="toastr" />
        <div :class="{blur: loading}">
            <b-row>
                <b-col cols="3">
                    <div class="social-box balance">
                        <i class="fa fa-money"></i>
                        <h5>Мой баланс</h5>
                        <ul>
                            <li><strong>{{ balance.eur }}</strong> <span>EUR</span></li>
                            <li><strong>{{ balance.spd }}</strong> <span>SPD</span></li>
                        </ul>
                    </div>
                </b-col>
                <b-col cols="3">
                    <div class="social-box deposits">
                        <i class="fa fa-shopping-bag"></i>
                        <h5>Мои депозиты</h5>
                        <ul>
                            <li><strong>{{ deposits.eur }}</strong> <span>EUR</span></li>
                            <li><strong>{{ deposits.spd }}</strong> <span>SPD</span></li>
                        </ul>
                    </div>
                </b-col>
                <b-col cols="3">
                    <div class="social-box referrals">
                        <i class="fa fa-users"></i>
                        <h5>Мои клиенты</h5>
                        <ul>
                            <li><strong>{{ balance.eur }}</strong> <span>Сегодня</span></li>
                            <li><strong>{{ balance.spd }}</strong> <span>Всего</span></li>
                        </ul>
                    </div>
                </b-col>
                <b-col cols="3">
                    <div class="social-box franchises">
                        <i class="fa fa-users"></i>
                        <h5>Мои франшизы</h5>
                        <ul>
                            <li><strong>{{ balance.eur }}</strong> <span>Агент</span></li>
                            <li><strong>{{ balance.spd }}</strong> <span>Супервайзер</span></li>
                        </ul>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-table class="table-outline" :items="lastPayments" />
                </b-col>
            </b-row>
        </div>
        <div v-if="loading" class="loading-container">
            <data-loading></data-loading>
        </div>
    </b-container>
</template>

<script>
    import DataLoading from '@/containers/DataLoading.vue'
    import Toastr from 'vue-toastr'

    export default {
        name: 'dashboard',
        components: {
            'data-loading': DataLoading,
            'vue-toastr': Toastr
        },
        data () {
            return {
                loading: false,

                balance: {
                    eur: 0,
                    spd: 0
                },
                deposits: {
                    eur: 0,
                    spd: 0
                },
                referrals: {
                    today: 0,
                    total: 0
                },
                franchises: {
                    agent: 0,
                    supervisor: 0
                },
                lastPayments: []
            }
        },
        mounted () {
            this.loadData()
        },
        methods: {
            loadData () {
                this.loading = true

                this.axios.get('users/summary')
                    .then(response => {
                        this.balance = response.data['balance']

                        if (response.data.hasOwnProperty('message') && response.data['message']) {
                            this.$refs['toastr'].i(response.data['message'])
                        }

                        setTimeout(() => {
                            this.loading = false
                        }, 500)
                    })
                    .catch(() => {
                        this.$refs['toastr'].e('Произошла ошибка')
                    })
            }
        }
    }
</script>

<style lang="scss">
    .social-box {
        min-height: 195px;

        &.balance i {
            color: #ffffff;
            background-color: #731D3A;
        }
        &.deposits i {
            color: #ffffff;
            background-color: #8FA800;
        }
        &.referrals i {
            color: #ffffff;
            background-color: #D65F36;
        }
        &.franchises i {
            color: #ffffff;
            background-color: #00793F;
        }

        h5 {
            margin: 8px 0 3px;
            text-transform: uppercase;
        }
    }
</style>


// WEBPACK FOOTER //
// Dashboard.vue?4eaac6e2